import { clearStaffSession, isJwtExpired, resolveBackendBaseUrl } from '../../../utils/runtimeConfig';

const API = `${resolveBackendBaseUrl()}/api`;

const toArray = (value) => (Array.isArray(value) ? value : []);

const normalizeTicketStatus = (value) => {
  const token = String(value || '').trim().toLowerCase();
  if (token === 'in_progress') return 'investigating';
  if (token === 'resolved') return 'mitigated';
  if (['open', 'investigating', 'mitigated', 'closed'].includes(token)) return token;
  return 'open';
};

const normalizeTicketPriority = (value) => {
  const token = String(value || '').trim().toLowerCase();
  return ['low', 'medium', 'high', 'critical'].includes(token) ? token : 'medium';
};

export const getAuthHeadersOrRedirect = (navigate) => {
  const token = localStorage.getItem('ktc_token');
  if (!token || isJwtExpired(token)) {
    clearStaffSession();
    if (typeof navigate === 'function') navigate('/dadu/login');
    return null;
  }
  return { Authorization: `Bearer ${token}` };
};

export const mapTicketItem = (item = {}) => ({
  ...item,
  id: String(item.id || ''),
  ticketCode: item.ticket_code || item.ticket_number || item.ticketCode || '-',
  status: normalizeTicketStatus(item.status),
  priority: normalizeTicketPriority(item.priority),
  assignedTo: item.assigned_to || item.assignee || '',
  sourceType: String(item.source_type || 'manual').toLowerCase(),
  sourceId: String(item.source_id || ''),
  customerId: String(item.customer_id || ''),
  incidentId: String(item.incident_id || ''),
  routerId: String(item.router_id || item.node_id || ''),
  nodeId: String(item.node_id || item.router_id || ''),
  siteId: String(item.site_id || ''),
  actionLog: toArray(item.action_log),
});

export async function fetchTickets({ headers, params = {} }) {
  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    query.set(key, String(value));
  });
  const response = await fetch(`${API}/tickets${query.toString() ? `?${query.toString()}` : ''}`, { headers });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload?.detail || 'Gagal memuat data ticket.');
  }
  const payload = await response.json();
  const items = toArray(payload?.items).map(mapTicketItem);
  return { items, total: Number(payload?.total || items.length) };
}

export async function createTicket({ headers, payload }) {
  const response = await fetch(`${API}/tickets`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...headers },
    body: JSON.stringify(payload || {}),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result?.detail || 'Gagal membuat ticket.');
  }
  return {
    item: mapTicketItem(result?.item || {}),
    warnings: toArray(result?.warnings || result?.item?.warnings),
  };
}

export async function appendTicketUpdate({ headers, ticketId, note }) {
  const response = await fetch(`${API}/tickets/${encodeURIComponent(String(ticketId || ''))}/updates`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...headers },
    body: JSON.stringify({ note }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result?.detail || 'Gagal menambah update ticket.');
  }
  return mapTicketItem(result?.item || {});
}

export async function patchTicket({ headers, ticketId, payload }) {
  const response = await fetch(`${API}/tickets/${encodeURIComponent(String(ticketId || ''))}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...headers },
    body: JSON.stringify(payload || {}),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result?.detail || 'Gagal memperbarui ticket.');
  }
  return mapTicketItem(result?.item || {});
}
